import React from 'react';
import { graphql } from 'gatsby';

import Profile from '../components/Profile';
import ProjectCard from '../components/ProjectCard';
import SEO from '../components/SEO';
import profiles from '../data/profile';

export const pageQuery = graphql`
  query IndexPage {
    allMarkdownRemark(
      filter: { frontmatter: { key: { in: ["sradar", "encodable", "boba_science"] } } }
      sort: { frontmatter: { date: DESC } }
      limit: 1000
    ) {
      edges {
        node {
          frontmatter {
            key
            title
            subtitle
            demoOnly
            demo
            thumbnail {
              extension
              publicURL
              childImageSharp {
                gatsbyImageData(width: 400, placeholder: BLURRED, layout: CONSTRAINED)
              }
            }
          }
        }
      }
    }
  }
`;

export default function Index({ data }: { data: Queries.IndexPageQuery }) {
  const projects = data.allMarkdownRemark.edges.map((e) => e.node.frontmatter);

  return (
    <>
      <div className="content-row hello">
        <div className="container">
          <div className="row">
            <div className="span10 offset1">
              <p className="hello-block center">
                I am a&nbsp;
                <strong>Data Visualization Engineer</strong>
                &nbsp;at&nbsp;
                <strong>Airbnb.</strong>
                <br />I invent and apply&nbsp;
                <strong>information visualization techniques</strong>
                <br />
                to explore and make sense of&nbsp;
                <strong>data.</strong>
              </p>
              <div className="center">
                <div className="social-media-block twitter" style={{ fontSize: '12px' }}>
                  <a href="https://twitter.com/kristw" className="twitter-follow-button" data-show-count="false">
                    Follow @kristw
                  </a>
                </div>
                <div className="social-media-block facebook">
                  <iframe
                    title="Like Button"
                    src="//www.facebook.com/plugins/like.php?href=http%3A%2F%2Fkristw.yellowpigz.com&amp;width=120&amp;height=21&amp;colorscheme=light&amp;layout=button_count&amp;action=like&amp;show_faces=false&amp;send=false&amp;appId=190131477823541"
                    scrolling="no"
                    frameBorder="0"
                    style={{ border: 'none', overflow: 'hidden', width: '120px', height: '21px' }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="content-row odd">
        <h1 className="section-title">Brief CV</h1>
        <div className="container">
          {profiles.map((p, i) => (
            <Profile key={[p.date, p.location].join('__')} profile={p} hiddenWhenSmall={i > 3} />
          ))}
          <div className="row">
            <div className="span10 offset1 center">
              <div className="download-link">
                Download full
                <a href="/file/resume_kristw.pdf">resume</a>
                or
                <a href="/file/cv_kristw.pdf">CV</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="content-row projects odd">
        <h1 className="section-title">Selected Work</h1>
        <div className="container">
          <div className="row">
            <div className="span12 center">
              <div className="project-container-wrapper">
                <div className="project-container">
                  {projects.map(
                    (frontmatter) => frontmatter != null && <ProjectCard key={frontmatter?.key} project={frontmatter} />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export const Head = () => {
  return <SEO title="" />;
};
